import { render, staticRenderFns } from "./folders-couterparties.vue?vue&type=template&id=398da20e&scoped=true"
import script from "./folders-couterparties.vue?vue&type=script&lang=js"
export * from "./folders-couterparties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398da20e",
  null
  
)

export default component.exports